import React, { useState } from "react";
import { useDispatch } from 'react-redux'
import { Menu, Sidebar, MenuItem, SubMenu } from "react-pro-sidebar";
import { useLocation } from "react-router-dom";
import { useProSidebar } from "react-pro-sidebar";
import { useSidebarContext } from "./sidebarContext";

import { Link } from "react-router-dom";
import { useTheme, Box, Typography, IconButton } from "@mui/material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import FlakyIcon from '@mui/icons-material/Flaky';
import SchoolIcon from '@mui/icons-material/School';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import StorageIcon from '@mui/icons-material/Storage';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar'; //legajo
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import AccountTreeIcon from '@mui/icons-material/AccountTree';

import logoBlanco from '../../../img/logo_blanco.png'
import logoColor from '../../../img/logo_color.png'

import { UserAuth } from "../../../context/AuthContext";

import AssignmentIcon from '@mui/icons-material/Assignment';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import ScienceIcon from '@mui/icons-material/Science';
import Groups3Icon from '@mui/icons-material/Groups3';
import Person4Icon from '@mui/icons-material/Person4';
import InfoIcon from '@mui/icons-material/Info';

import Tooltip from '@mui/material/Tooltip';

const Item = ({ title, to, icon, selected, setSelected }) => {
    const theme = useTheme();
    const colors = theme.palette
    return (
        <MenuItem
            active={selected === to}
            // style={{ color: colors.secondary[300] }}
            onClick={() => setSelected(to)}
            icon={icon}
            routerLink={<Link to={to} />}
        >
            <Typography
                variant="h7"
                sx={{
                    fontSize: '13px',
                    fontWeight: selected === to ? 'bold' : 'normal',
                }}
            >
                {title}
            </Typography>
        </MenuItem>
    );
};


const MyProSidebar = () => {
    const theme = useTheme();
    const [selected, setSelected] = useState("");
    const { sidebarRTL, setSidebarRTL, sidebarImage } = useSidebarContext();
    const { collapseSidebar, toggleSidebar, collapsed, broken } = useProSidebar();
    const { pathname } = useLocation();
    const { empleado } = UserAuth()

    React.useEffect(() => {
        setSelected(pathname);
    }, [pathname]);

    return Object.keys(empleado).length > 0 && (
        <Box
            sx={{
                position: "sticky",
                display: "flex",
                height: "100vh",
                top: 0,
                bottom: 0,
                zIndex: 3,
                "& .sidebar": {
                    border: "none",
                },
                "& .menu-icon": {
                    // color: theme.palette.mode === 'light' && '#32507A',
                    backgroundColor: "transparent !important",
                },
                "& .menu-item": {
                    // padding: "5px 35px 5px 20px !important",
                    backgroundColor: "transparent !important",
                    "&.active": {
                        color: theme.palette.mode === 'dark' ? theme.palette.tertiary[500] + ' !important' : theme.palette.tertiary[600],
                    },
                },
                "& .menu-anchor": {
                    color: "inherit !important",
                    backgroundColor: "transparent !important",
                },
                "& .menu-item:not(.sub-menu)": {
                    // Estilos para los menu-items que no son parte del submenu
                    backgroundColor: "transparent !important",
                    "&.active": {
                        color:
                            theme.palette.mode === "dark"
                                ? theme.palette.tertiary[500] + " !important"
                                : theme.palette.tertiary[600],
                    },
                    "&:hover": {
                        color:
                            theme.palette.mode === "dark"
                                ? theme.palette.secondary[500] + " !important"
                                : theme.palette.tertiary[600],
                        backgroundColor: "transparent !important",
                    },
                },
                "& .sub-menu-content": {
                    backgroundColor: theme.palette.primary.main,
                },
            }}
        >
            <Sidebar
                breakPoint="md"
                rtl={sidebarRTL}
                backgroundColor={theme.palette.primary.main}
                image={sidebarImage}
                transitionDuration={500}
            >
                <Menu iconshape="square">
                    <MenuItem
                        icon={
                            collapsed && (
                                <MenuOutlinedIcon onClick={() => collapseSidebar()} />
                            )
                        }
                        style={{
                            margin: "10px 0 20px 0",
                        }}
                    >

                        {!collapsed && (
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                style={{ maxWidth: "100%" }}
                            >

                                <IconButton
                                    onClick={
                                        broken ? () => toggleSidebar() : () => collapseSidebar()
                                    }
                                    style={{ flexShrink: 0 }}
                                >
                                    <CloseOutlinedIcon />
                                </IconButton>
                            </Box>
                        )}
                    </MenuItem>
                    <Box paddingLeft={collapsed ? undefined : "0%"}>
                        <Item
                            title="Inicio"
                            to="/inicio"
                            icon={<HomeOutlinedIcon />}
                            selected={selected}
                            setSelected={setSelected}
                        />
                        <Item
                            title="Legajo"
                            to="/legajo"
                            icon={<PermContactCalendarIcon />}
                            selected={selected}
                            setSelected={setSelected}
                        />

                        {empleado && empleado.puesto === "codocente" && (
                            <>
                                <Item
                                    title="GH Responde"
                                    to="/gh-responde"
                                    icon={<FlakyIcon />}
                                    selected={selected}
                                    setSelected={setSelected}
                                />
                                <Item
                                    title="Universidad Interna"
                                    to="/universidad-interna"
                                    icon={<SchoolIcon />}
                                    selected={selected}
                                    setSelected={setSelected}
                                />
                                <Item
                                    title="Novedades por liquidación"
                                    to="/novedades-liquidacion"
                                    icon={<RequestQuoteIcon />}
                                    selected={selected}
                                    setSelected={setSelected}
                                />
                                <Item
                                    title="Licencias"
                                    to="/licencias"
                                    icon={<ReceiptLongIcon />}
                                    selected={selected}
                                    setSelected={setSelected}
                                />

                                <Item
                                    title="Vacaciones"
                                    to="/vacaciones"
                                    icon={<FlightTakeoffIcon />}
                                    selected={selected}
                                    setSelected={setSelected}
                                />
                                <Item
                                    title="PGD"
                                    to="/pgd"
                                    icon={<ManageAccountsIcon />}
                                    selected={selected}
                                    setSelected={setSelected}
                                />

                                <Item
                                    title="Organigrama"
                                    to="/organigrama"
                                    icon={<AccountTreeIcon />}
                                    selected={selected}
                                    setSelected={setSelected}
                                />
                            </>
                        )}
                        <Item
                            title="Solicitudes"
                            to="/solicitudes"
                            icon={<PendingActionsIcon />}
                            selected={selected}
                            setSelected={setSelected}
                        />
                        {empleado && empleado.puesto === "docente" && (
                            <>
                                <Item
                                    title="Desempeño"
                                    to="/desempeno"
                                    icon={<QueryStatsIcon />}
                                    selected={selected}
                                    setSelected={setSelected}
                                />


                                <SubMenu label="Área académica" icon={<HistoryEduIcon />}>
                                    <Tooltip title="Formación" placement="right" arrow>
                                        <MenuItem>
                                            <Item
                                                title="Formación"
                                                to="/formacion"
                                                icon={<AssignmentIcon />}
                                                selected={selected}
                                                setSelected={setSelected}
                                            />

                                        </MenuItem>
                                    </Tooltip>
                                    <Tooltip title="Área principal de desempeño de profesional" placement="right" arrow>
                                        <MenuItem>

                                            <Item
                                                title="Área principal de desempeño de profesional"
                                                to="/area-principal"
                                                icon={<SupervisedUserCircleIcon />}
                                                selected={selected}
                                                setSelected={setSelected}
                                            />
                                        </MenuItem>
                                    </Tooltip>
                                    <Tooltip title="Docencia univeritaria" placement="right" arrow>
                                        <MenuItem>
                                            <Item
                                                title="Docencia univeritaria"
                                                to="/docencia-universitaria"
                                                icon={<SchoolIcon />}
                                                selected={selected}
                                                setSelected={setSelected}
                                            />
                                        </MenuItem>
                                    </Tooltip>
                                    <Tooltip title="Investigación" placement="right" arrow>
                                        <MenuItem>
                                            <Item
                                                title="Investigación"
                                                to="/investigacion"
                                                icon={<ScienceIcon />}
                                                selected={selected}
                                                setSelected={setSelected}
                                            />
                                        </MenuItem>
                                    </Tooltip>
                                    <Tooltip title="Reuniones científicas" placement="right" arrow>
                                        <MenuItem>
                                            <Item
                                                title="Reuniones científicas"
                                                to="/reuniones-cientificas"
                                                icon={<Groups3Icon />}
                                                selected={selected}
                                                setSelected={setSelected}
                                            />
                                        </MenuItem>
                                    </Tooltip>
                                    <Tooltip title="Comités y jurados" placement="right" arrow>
                                        <MenuItem>
                                            <Item
                                                title="Comités y jurados"
                                                to="/comites-jurados"
                                                icon={<Person4Icon />}
                                                selected={selected}
                                                setSelected={setSelected}
                                            />
                                        </MenuItem>
                                    </Tooltip>
                                    <Tooltip title="Otra información" placement="right" arrow>
                                        <MenuItem>
                                            <Item
                                                title="Otra información"
                                                to="/otra-informacion"
                                                icon={<InfoIcon />}
                                                selected={selected}
                                                setSelected={setSelected}
                                            />
                                        </MenuItem>
                                    </Tooltip>
                                </SubMenu>

                                <Item
                                    title="GD Responde"
                                    to="/gd-responde"
                                    icon={<FlakyIcon />}
                                    selected={selected}
                                    setSelected={setSelected}
                                />
                                <Item
                                    title="Asignaciones"
                                    to="/asignaciones"
                                    icon={<StorageIcon />}
                                    selected={selected}
                                    setSelected={setSelected}
                                />
                                <Item
                                    title="Universidad Interna"
                                    to="/universidad-interna-docente"
                                    icon={<SchoolIcon />}
                                    selected={selected}
                                    setSelected={setSelected}
                                />
                                <Item
                                    title="Evaluaciones"
                                    to="/evaluaciones"
                                    icon={<AssignmentTurnedInIcon />}
                                    selected={selected}
                                    setSelected={setSelected}
                                />
                            </>
                        )}



                    </Box>
                </Menu>
                {!collapsed ?
                    <Box sx={{
                        position: "relative",
                        bottom: 0,
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        padding: "20px"
                    }}>
                        {
                            theme.palette.mode == 'dark' ?
                                <img src={logoBlanco} alt="Logo Responsive" style={!collapsed ? { height: "5.2rem" } : { height: "1.8rem" }} /> :
                                <img src={logoColor} alt="Logo Responsive" style={!collapsed ? { height: "5.2rem", animation: "width-increase 3s ease infinite" } : { height: "1.8rem", animation: "width-increase 3s ease infinite" }} />
                        }
                    </Box>
                    :
                    null
                }
            </Sidebar>
        </Box>
    );
};

export default MyProSidebar;
